import styled from 'styled-components'

import { colors } from '../../theme'
import Icon from '../Icon'
import Select from '../Select'

export const Container = styled.header`
  width: 100%;
  background: ${colors.pureWhite};
  border-bottom: 1px solid ${colors.pureBlack};
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
`

export const LogoIcon = styled(Icon)`
  width: 13.7rem;
`

export const LocaleSelect = styled(Select)`
  width: 115px;
`
